import { motion } from 'framer-motion';
import React, { useMemo } from 'react';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';
import LilHeads from '../../../components/LilHeads';
import LiveSessionTime from '../../../components/LiveSessionTime';
import LiveSessionType from '../../../components/LiveSessionType';
import DOMPurify from 'dompurify';
interface InformationContainerProps {
  content: any;
  onViewPost: (content: any) => void;
  numAttending: number;
  showCancelLink: boolean;
  onCancelMeeting: (e) => void;
}
const InformationContainer: React.FC<InformationContainerProps> = ({ ...props }) => {
  const sanitizedSocialDescription = useMemo(() => {
    return DOMPurify.sanitize(props.content.SocialDescription as string, {});
  }, [props.content.SocialDescription]);

  const sanitizedName = useMemo(() => {
    return DOMPurify.sanitize(props.content.Name as string, {});
  }, [props.content.Name]);

  const handleClick = () => {
    props.onViewPost({ mContent: props.content });
    App.INSTANCE.firehoseActivity(
      ANALYTICS_CONFIGURATION.FIREHOSE_OBJECTS.OBJECT_CONTENT,
      props.content.Id,
      App.INSTANCE.appRouter.lastRouteResolvedUrl(),
      App.INSTANCE.CurrentUser.Id,
      props.content.FirstBucketName(),
      ANALYTICS_CONFIGURATION.FIREHOSE_ACTIONS.ACTION_CLICK.value,
      null,
      null,
    );
    App.INSTANCE.reportActivity(
      props.content.Id,
      'Schedule Row',
      'Clicked',
      App.INSTANCE.appRouter.lastRouteResolvedUrl(),
      null,
      null,
    );
  };

  const hideAttendees = showOrHideAttendees(props.content);
  const userCreatedMeeting = +props.content.RawData.content_author === App.INSTANCE.CurrentUser.Id;
  return (
    <div>
      <button className="information_container" onClick={handleClick} aria-label="Go to session" tabIndex={0}>
        <div className="time_and_type_container">
          <div className="type_container">
            <LiveSessionType content={props.content} />
          </div>
          <div className="time_container">
            <LiveSessionTime content={props.content} />
          </div>
          {props.content.RawData.canDelete && userCreatedMeeting && (
            <div className="cancel_container">
              {props.showCancelLink && (
                <div className="cancel_link">
                  <div className="delete brand_color_color" onClick={props.onCancelMeeting}>
                    Cancel Meeting
                  </div>
                </div>
              )}
              {!props.showCancelLink && (
                <div className="cancel_status">
                  <i>{CrowdHub_App.LANG.B2B_CANCEL_MEETING_CANCELED}</i>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="title_container" dangerouslySetInnerHTML={{ __html: sanitizedName }} />
        <div className="subtitle_container" dangerouslySetInnerHTML={{ __html: sanitizedSocialDescription }} />
      </button>
      {!hideAttendees && (
        <div className="attending_information_container">
          <div className="lil_heads_container">
            <LilHeads content={props.content} />
          </div>
          <div className="attending_container">
            {CrowdHub_App.LANG.MEMBERS_ATTENDING.replace('*|COUNT|*', props.numAttending)}
          </div>
          {isLocked(props.content) && (
            <i className={`lock_icon brand_color_color ${FontAwesomeConfigurations.ICON_LOCK_KEYHOLE_SOLID}`} />
          )}
        </div>
      )}
    </div>
  );
};

const isLocked = content => {
  if (App.INSTANCE.CurrentUser.IsLoggedIn() == true) {
    if (content.hasAccess()) {
      return false;
    } else {
      if (!content.ContainsTagName('do not preview')) {
        return false;
      }
    }
  } else {
    if (!content.ContainsTagName('do not preview')) {
      return false;
    }
  }
  return true;
};

const showOrHideAttendees = content => {
  // default to the main config for all
  let hideAttendees = CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT;

  // if we are not already hiding all of them, check the state
  if (!hideAttendees) {
    // check my current state
    switch (content.currentState()) {
      case JunoContent.STATE_LIVE:
        hideAttendees = CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT_LIVE;
        break;
      case JunoContent.STATE_PAST:
        hideAttendees = CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT_PAST;
        break;
      case JunoContent.STATE_UPCOMING:
        hideAttendees = CrowdHub_App.CONFIG.HIDE_ATTENDEE_COUNT_UPCOMING;
        break;
      default:
        break;
    }
  }

  // hiding both the livesession_members elements and the members_attending_container element
  return hideAttendees;
};

export default InformationContainer;
